module.exports = __webpack_public_path__ + "img/FernandoSarinana.1b0be007.png";